import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkText } from "uitk-react-text";
import { ProductTypeContext } from "components/flexComponents/TopCities/TopCities";

const ProductPriceSupportText = () => {
  const productType = React.useContext(ProductTypeContext);
  const { formatText } = useLocalization();

  const priceSupportText = {
    hotels: formatText("topCities.hotels.perNightRoom"),
    flights: formatText("topCities.flights.roundtrip"),
    cars: formatText("topCities.cars.perDay"),
    packages: formatText("topCities.packages.flightAndHotelPerPerson"),
    vacation_rentals: formatText("topCities.hotels.perNightRoom"),
    accommodations: formatText("topCities.hotels.perNightRoom"),
  };

  return <UitkText size={300}>{priceSupportText[productType]}</UitkText>;
};

export default ProductPriceSupportText;
